<glxy-table-container [dataSource]="dataSource" [columns]="columns" [border]="true" [showFooter]="false">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange($event)">
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>

    <ng-container matColumnDef="rank">
      <th mat-header-cell *matHeaderCellDef>{{ 'LEADERBOARD.COLUMNS.RANK' | translate }}</th>
      <td mat-cell *matCellDef="let index = index">{{ index + 1 }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'LEADERBOARD.COLUMNS.NAME' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="name-container">
          <glxy-avatar class="avatar" [src]="element.profilePicture" [name]="element.fullName" [width]="32" />
          @if (element.fullName) {
            <span>{{ element.fullName }}</span>
          } @else {
            <span>{{ 'LEADERBOARD.DELETED_USER' | translate }}</span>
          }
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <glxy-form-field bottomSpacing="none" [showLabel]="false">
          <mat-select [(ngModel)]="footerType">
            <mat-option value="total">{{ 'LEADERBOARD.AGGREGATIONS.TOTAL' | translate }}</mat-option>
            <mat-option value="average">{{ 'LEADERBOARD.AGGREGATIONS.AVERAGE' | translate }}</mat-option>
          </mat-select>
        </glxy-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="inboundCall">
      <th mat-header-cell mat-sort-header *matHeaderCellDef arrowPosition="before">
        {{ 'LEADERBOARD.COLUMNS.INBOUND_CALLS' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.count.inboundCall }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ footerData().inboundCall | number: '1.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="outboundCall">
      <th mat-header-cell mat-sort-header *matHeaderCellDef arrowPosition="before">
        {{ 'LEADERBOARD.COLUMNS.OUTBOUND_CALLS' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.count.outboundCall }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ footerData().outboundCall | number: '1.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="inboundEmail">
      <th mat-header-cell mat-sort-header *matHeaderCellDef arrowPosition="before">
        {{ 'LEADERBOARD.COLUMNS.INBOUND_EMAILS' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.count.inboundEmail }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ footerData().inboundEmail | number: '1.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="outboundEmail">
      <th mat-header-cell mat-sort-header *matHeaderCellDef arrowPosition="before">
        {{ 'LEADERBOARD.COLUMNS.OUTBOUND_EMAILS' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.count.outboundEmail }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ footerData().outboundEmail | number: '1.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="meeting">
      <th mat-header-cell mat-sort-header *matHeaderCellDef arrowPosition="before">
        {{ 'LEADERBOARD.COLUMNS.MEETINGS' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.count.meeting }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ footerData().meeting | number: '1.0-2' }}</td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>
  </table>
</glxy-table-container>
